import get from 'lodash/get';
import {RawQos} from '@techsee/techsee-media-service/lib/qos/raw-qos';
import {getRootStore} from '../../app.bootstrap';
import {getAppTracer} from '../../../app.tracer';
import {IQosService} from '@techsee/techsee-client-infra/lib/services/QosService';
import {ITsEnvironmentDetect} from '@techsee/techsee-common/lib/helpers/ts-environment-detect';
import {IRoom} from '../../models/Room';
import {IUser} from '../../models/User';
import {IAccountData} from '@techsee/techsee-common/lib/constants/account.constants';

declare const DEBUG_QOS: boolean;

const trace = getAppTracer('AgentQOSService');

interface Environment {
    browser: any;
    deviceType: string | undefined;
    osName: string | undefined;
}

interface StatsReport {
    [key: string]: string;
}

export interface IAgentQOSService {
    init(accountData: IAccountData, currentUser: IUser, roomData: IRoom): void;
    sendQOS(statsReports: StatsReport[]): Promise<any>;
}

export class AgentQOSService implements IAgentQOSService {
    private environmentDetect: ITsEnvironmentDetect;
    private qosService: IQosService;
    private accountData!: IAccountData;
    private currentUser!: IUser;
    private roomData!: IRoom;

    constructor() {
        this.environmentDetect = getRootStore().environmentService;
        this.qosService = getRootStore().qosService;
    }

    public init(accountData: IAccountData, currentUser: IUser, roomData: IRoom): void {
        this.accountData = accountData;
        this.currentUser = currentUser;
        this.roomData = roomData;
    }

    public sendQOS(statsReports: StatsReport[]): Promise<any> {
        return new Promise((resolve) => {
            if (DEBUG_QOS) {
                trace.info('dump all stats:', this._dumpAllStats(statsReports));
            }

            const entry: any = new RawQos().parse(statsReports);

            entry.type = 'agent';
            entry.enviroment = this._getEnviroment();
            entry.accountId = get(this.accountData, '_id');
            entry.accountName = get(this.accountData, 'companyName');
            entry.userId = get(this.currentUser, '_id');
            entry.roomId = get(this.roomData, '_id');

            this._debugQos(entry);

            resolve(
                this.qosService.addClientQos(entry.type, entry.accountId, entry.userId, entry.roomId, entry.enviroment)
            );
        });
    }

    private _getEnviroment(): Environment {
        return {
            browser: this.environmentDetect.browser(),
            deviceType: this.environmentDetect.deviceType(),
            osName: this.environmentDetect.osName()
        };
    }

    private _debugQos(entry: any): void {
        if (DEBUG_QOS) {
            const r = entry.raw;
            entry.raw = [];
            entry.raw = r;
        }
    }

    private _dumpAllStats(results: StatsReport[]): string {
        let statsString = '';

        results.forEach((res) => {
            statsString += this._dumpOne(res);
        });

        return '[' + statsString + ']';
    }

    private _dumpOne(res: StatsReport): string {
        let statsString = '{';
        let index = 0;
        const keys = Object.keys(res);

        keys.forEach((k) => {
            statsString += `"${k}": "${res[k]}"`;
            if (++index !== keys.length) {
                statsString += ',';
            }
        });
        statsString += '}';

        return statsString;
    }
}
